import { render, staticRenderFns } from "./ListBonos.vue?vue&type=template&id=a1189b56&"
import script from "./ListBonos.vue?vue&type=script&lang=js&"
export * from "./ListBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports